export function removeUrlParam(paramName) {
	if (typeof globalThis.window !== "undefined") {
		const newUrl = new URL(globalThis.location.href);
		newUrl.searchParams.delete(paramName);
		globalThis.history.replaceState({}, "", newUrl.toString());
	}
}

export const setLocation = (path, timeout = 300) => {
	if (typeof globalThis.window !== "undefined") {
		// Wait 300ms for any tracking events to flush
		setTimeout(() => {
			globalThis.location.href = path;
		}, timeout);
	}
};

/**
 * Calculate distance between two coordinates
 */
export function getDistance(lat1, lon1, lat2, lon2, unit = "miles") {
	if ([lat1, lon1, lat2, lon2].some((n) => typeof n !== "number"))
		return null;

	const toRad = (deg) => deg * (Math.PI / 180);
	const R = unit === "miles" ? 3958.8 : 6371;

	const dLat = toRad(lat2 - lat1);
	const dLon = toRad(lon2 - lon1);

	const a =
		Math.sin(dLat / 2) ** 2 +
		Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

	const distance = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	const rounded = Math.round(distance);

	return rounded;
}

// Formats a number compactly (e.g., 1500 -> "1K", 2000000 -> "2M")
export function formatCountCompact(count) {
	const num = Number(count) || 0;
	if (num < 1000) return String(num);
	if (num < 1_000_000) return `${Math.floor(num / 1000)}K`;
	if (num < 1_000_000_000) return `${Math.floor(num / 1_000_000)}M`;
	return `${Math.floor(num / 1_000_000_000)}B`;
}
